import { isUndefined, capitalize, isFunction } from 'lodash';
import t from 'common/i18n';
import joinNonEmpty from 'utils/joinNonEmpty';
import consts from '../data/consts';
import { initialFilters } from '../data/ShutterStockRecord';

const IMG_TYPE_DEF = {
  filter: 'type',
  default: initialFilters.type,
  result: capitalize,
};

const GENDER_DEF = {
  filter: 'gender',
  default: initialFilters.gender,
  result: 'shutterstock.filter_summary.gender',
};

const PEOPLE_DEF = {
  filter: 'withPeopleOnly',
  default: initialFilters.withPeopleOnly,
  result: (r, filters) => t('shutterstock.filter_summary.people', { value: filters.numberOfPeople }),
  subs: [GENDER_DEF], // only show gender if people filter enabled
};

const CATEGORY_DEF = {
  filter: 'category',
  default: initialFilters.category,
  result: (r, filters, state) => {
    const category = state.categories.find((c) => c.value === r);
    return category && t('shutterstock.filter_summary.category', { value: category.label });
  },
};

const ORIENT_DEF = {
  filter: 'orientation',
  default: initialFilters.orientation,
  result: capitalize,
};

const findColor = (hex) => {
  const color = consts.COLORS.find((c) => c.value === hex);
  return color ? t(color.label) : hex;
};

const COLOR_DEF = {
  filter: 'color',
  default: initialFilters.color,
  result: (c) => t('shutterstock.filter_summary.color', { value: findColor(c) }),
};

const SAFE_DEF = {
  filter: 'safe',
  default: initialFilters.safe,
  result: 'shutterstock.filter_summary.unsafe',
};

const DURATION_DEF = {
  filter: 'duration',
  default: initialFilters.duration,
  result: capitalize,
};

const RES_DEF = {
  filter: 'resolution',
  default: initialFilters.resolution,
  result: (r) => t(`shutterstock.filters.resolution.${r}`),
};

const IMAGE_DEFINITION = [IMG_TYPE_DEF, ORIENT_DEF, PEOPLE_DEF, CATEGORY_DEF, COLOR_DEF, SAFE_DEF];

const VIDEO_DEFINITION = [DURATION_DEF, RES_DEF, PEOPLE_DEF, CATEGORY_DEF, SAFE_DEF];

const processDefinition = (definition, filters, state) => {
  if (filters.color && filters.color[0] !== '#') {
    filters = { ...filters, color: `#${filters.color}` };
  }

  const value = filters[definition.filter];

  let result;
  let subResults;

  if (isUndefined(definition.default) || value !== definition.default) {
    result = definition.result
      ? isFunction(definition.result)
        ? // use converter function:
          definition.result(value, filters, state)
        : // use dictionary entry:
          t(definition.result, { value })
      : // use value as is:
        value;

    subResults = definition.subs ? definition.subs.map((def) => processDefinition(def, filters, state)) : [];
  }

  return joinNonEmpty([result].concat(subResults));
};

const buildSummary = (definitions, filters, state) => {
  const summaryParts = definitions.map((def) => processDefinition(def, filters, state));

  return joinNonEmpty(summaryParts);
};

const buildSummaryForImages = (filters, state) => buildSummary(IMAGE_DEFINITION, filters, state);

const buildSummaryForVideos = (filters, state) => buildSummary(VIDEO_DEFINITION, filters, state);

export default (mediaType, filters, state) =>
  mediaType === consts.MEDIA_TYPES.IMAGES ? buildSummaryForImages(filters, state) : buildSummaryForVideos(filters, state);
